import { render, staticRenderFns } from "./email.vue?vue&type=template&id=aa432fae&scoped=true&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"
import style0 from "./email.vue?vue&type=style&index=0&id=aa432fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa432fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa432fae')) {
      api.createRecord('aa432fae', component.options)
    } else {
      api.reload('aa432fae', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=aa432fae&scoped=true&", function () {
      api.rerender('aa432fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/email.vue"
export default component.exports